module.exports = __webpack_public_path__ + "img/fr-20r.2c3ecb76.svg";